import { Card, Descriptions, Space, Tag } from "antd";
import type { IntakeItem } from "./types";
import InlineEditable from "./InlineEditable";

interface Props {
  intake: IntakeItem;
  /** Called when an editable top-level field is saved. */
  onFieldEdit?: (field: keyof IntakeItem, value: string) => Promise<void>;
  canEdit?: boolean;
}

export default function MetadataTab({ intake, onFieldEdit, canEdit = false }: Props) {
  const editProps = (field: keyof IntakeItem) => ({
    value: (intake[field] as string | undefined) || "",
    canEdit: Boolean(canEdit && onFieldEdit),
    ariaLabel: String(field),
    onSave: async (next: string) => {
      if (!onFieldEdit) return;
      await onFieldEdit(field, next);
    },
  });

  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      <Card>
        <Descriptions column={1} size="small" bordered>
          <Descriptions.Item label="Name">
            <InlineEditable {...editProps("intakeName")} />
          </Descriptions.Item>
          <Descriptions.Item label="Description">
            <InlineEditable {...editProps("intakeDescription")} multiline />
          </Descriptions.Item>
          <Descriptions.Item label="Submitter">
            {intake.submitterName || "—"}
          </Descriptions.Item>
          <Descriptions.Item label="Email">
            {intake.submitterEmail || "—"}
          </Descriptions.Item>
          <Descriptions.Item label="Submitter Agency">
            {intake.submitterAgency || "—"}
          </Descriptions.Item>
          <Descriptions.Item label="Agency (canonical)">
            <InlineEditable {...editProps("agencyName" as keyof IntakeItem)} />
          </Descriptions.Item>
          <Descriptions.Item label="Submitted">
            {intake.submittedAt || intake.createdAt
              ? new Date(intake.submittedAt || intake.createdAt || "").toLocaleString()
              : "—"}
          </Descriptions.Item>
          <Descriptions.Item label="Type">{intake.type || "agency"}</Descriptions.Item>
          <Descriptions.Item label="Source">
            <InlineEditable {...editProps("source" as keyof IntakeItem)} />
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag>{intake.status || "Submitted"}</Tag>
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </Space>
  );
}
